module.exports = function(shared){

  var $location = shared.$location;
  var vm = shared.vm;
  var Role_Account_Manager = shared.Role_Account_Manager;

  var usage = vm.usage = {};

  usage.details = function(item){
    var refUrl = agneta.langPath({
      path: 'edit/data-remote',
      query:{
        id: item.refId,
        template: 'event_booking'
      }
    });
    $location.url(refUrl);
  };

  usage.load = function() {
    Role_Account_Manager.usageList({
      memberId: vm.member.id
    })
      .$promise
      .then(function(result){
        //console.log(result);
        vm.usages = result;
      })
      .finally(function(){
        vm.loading = false;
      });
  };

};
